import React from 'react';
import Section from '../Contact/Section'
import ContactContent from '../Contact/ContactContent';
import MetaTags from '../../helpers/Common/MetaTags';
import { getMetaConfig } from '../../helpers/Common/metaConfig';

const Contact = () => {
    const contactMeta = getMetaConfig('contactUs');
    
    return (
        <React.Fragment>
            <MetaTags {...contactMeta} />
            <Section/>
            <ContactContent/>
        </React.Fragment>
    )
}

export default Contact;
